import { render, staticRenderFns } from "./AuditHistoryComponent.vue?vue&type=template&id=638c4a46&"
import script from "./AuditHistoryComponent.vue?vue&type=script&lang=js&"
export * from "./AuditHistoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports